<div class='width-800'>

  <div class='img-box'>
    <img src="assets/images/geral/logo_azul.png">
  </div>


  <mat-card>
    <div *ngIf="emailData" style="font-size: 1.4em;">
      <b>{{emailData.subject}}</b>
    </div>
  </mat-card>


  <div *ngIf="!flagDone">
    <mat-card *ngIf="emailData">

      <div *ngIf="emailData.letter_type == '1'" [innerHtml]='emailData.text'>
      </div>

      <div *ngIf="emailData.letter_type == '0'" [innerHtml]='emailData.text_back'>
      </div>

      <div class='button-wrapper' *ngIf="emailData.letter_type == '0'">

        <button mat-raised-button (click)='updateAccept(false)' style='background-color: darkblue; color: white;'>
          Aceitar
        </button> <!--[disabled]="fired"-->

        <button mat-raised-button (click)='updateAccept(true)' style='background-color: darkblue; color: white;'>
          Recusar
        </button> <!--[disabled]="fired"-->

      </div>

    </mat-card>
  </div>

  <div *ngIf="flagDone">
    <mat-card>
      <p>Sua resposta foi registrada com sucesso!</p>
      <p>Obrigado por participar.</p>
      <p>Equipe SBCCV</p>
    </mat-card>
  </div>


</div>